/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type TaskResourceType = 'NONE' | 'DEPLOYMENT' | 'AWS_ACCOUNT' | 'REQUEST_ACCESS' | 'SUBSCRIPTION' | 'RELEASE' | 'RANSOMWARE_RECOVERY_DEPLOYMENT' | 'VMCFS_DEPLOYMENT' | 'SEED_OAUTH_APP' | 'MAINTENANCE' | 'DATASTORE' | 'AGENT' | 'AGENT_RECONFIGURE_JOB' | 'VCF_OAUTH_APP' | 'VMC_OAUTH_APP' | 'VMC_POOL' | 'DISCONNECTED_DEPLOYMENT' | 'SDDC' | 'MONITOR' | 'VCF' | 'VMC' | 'VMCA' | 'DRC' | 'SRM_AGENT' | 'ASUP' | 'MULTIPLE_OAUTH_APPS';

export const TaskResourceType = {

    NONE: 'NONE' as TaskResourceType,

    DEPLOYMENT: 'DEPLOYMENT' as TaskResourceType,

    AWS_ACCOUNT: 'AWS_ACCOUNT' as TaskResourceType,

    REQUEST_ACCESS: 'REQUEST_ACCESS' as TaskResourceType,

    SUBSCRIPTION: 'SUBSCRIPTION' as TaskResourceType,

    RELEASE: 'RELEASE' as TaskResourceType,

    RANSOMWARE_RECOVERY_DEPLOYMENT: 'RANSOMWARE_RECOVERY_DEPLOYMENT' as TaskResourceType,

    VMCFS_DEPLOYMENT: 'VMCFS_DEPLOYMENT' as TaskResourceType,

    SEED_OAUTH_APP: 'SEED_OAUTH_APP' as TaskResourceType,

    MAINTENANCE: 'MAINTENANCE' as TaskResourceType,

    DATASTORE: 'DATASTORE' as TaskResourceType,

    AGENT: 'AGENT' as TaskResourceType,

    AGENT_RECONFIGURE_JOB: 'AGENT_RECONFIGURE_JOB' as TaskResourceType,

    VCF_OAUTH_APP: 'VCF_OAUTH_APP' as TaskResourceType,

    VMC_OAUTH_APP: 'VMC_OAUTH_APP' as TaskResourceType,

    VMC_POOL: 'VMC_POOL' as TaskResourceType,

    DISCONNECTED_DEPLOYMENT: 'DISCONNECTED_DEPLOYMENT' as TaskResourceType,

    SDDC: 'SDDC' as TaskResourceType,

    MONITOR: 'MONITOR' as TaskResourceType,

    VCF: 'VCF' as TaskResourceType,

    VMC: 'VMC' as TaskResourceType,

    VMCA: 'VMCA' as TaskResourceType,

    DRC: 'DRC' as TaskResourceType,

    SRM_AGENT: 'SRM_AGENT' as TaskResourceType,

    ASUP: 'ASUP' as TaskResourceType,

    MULTIPLE_OAUTH_APPS: 'MULTIPLE_OAUTH_APPS' as TaskResourceType
};

